/* OWNLUXE PRODUCT-CARD REVIEWS — 18 JUL 2026
   Detects when Ali Reviews fills its product-card badge and hides the metafield fallback.
   Also supports cards appended by collection, search, homepage, and category infinite scroll. */
(function() {
  var selector = '[data-ownluxe-card-reviews]';
  var queued = false;

  function appBadgeHasContent(appBadge) {
    if (!appBadge) return false;
    if ((appBadge.textContent || '').trim().length > 0) return true;
    return Boolean(appBadge.querySelector('svg, img, i, span, [class*="star"], [class*="rating"], [class*="review"]'));
  }

  function findCards(scope) {
    var cards = [];
    if (scope && scope.matches && scope.matches(selector)) cards.push(scope);
    if (scope && scope.querySelectorAll) {
      cards = cards.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    }
    return cards;
  }

  function update(scope) {
    findCards(scope || document).forEach(function(card) {
      var appBadge = card.querySelector('[data-ownluxe-review-app]');
      card.classList.toggle('is-app-loaded', appBadgeHasContent(appBadge));
    });
  }

  function queueUpdate() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function() {
      queued = false;
      update(document);
    });
  }

  function start() {
    update(document);
    if ('MutationObserver' in window && document.body) {
      var observer = new MutationObserver(queueUpdate);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function(event) { update(event.target); });
  document.addEventListener('ownluxe:products:added', function(event) {
    update(event.detail && event.detail.root ? event.detail.root : document);
  });
})();
